// src/pages/Speech.jsx
import React, { useState, useLayoutEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';
import backgroundImage from '../assets/background.png';

const Speech = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(false); // ⬅️ 預設收起

  /* --- 螢幕尺寸監聽 (同步) --- */
  useLayoutEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handleMatch = (e) => setIsMobile(e.matches);

    handleMatch(mq);                     // 初始判斷
    mq.addEventListener('change', handleMatch);
    return () => mq.removeEventListener('change', handleMatch);
  }, []);

  /* --- 進頁面時保證 Sidebar 收起 (再次保險) --- */
  useLayoutEffect(() => {
    setSidebarExpanded(false);
  }, []);

  /* --- Sidebar onToggle --- */
  const handleSidebarToggle = (expanded) => setSidebarExpanded(expanded);

  /* --- 行動版才需要遮罩 --- */
  const showOverlay = sidebarExpanded && isMobile;

  return (
    <div style={{ display: 'flex', position: 'relative' }}>
      {/* 遮罩（點擊即可收起 Sidebar） */}
      {showOverlay && (
        <div
          className="overlay"
          onClick={() => setSidebarExpanded(false)}
        />
      )}

      <Sidebar onToggle={handleSidebarToggle} />

      <div
        className="main-content"
        style={{
          marginLeft: isMobile ? '0' : sidebarExpanded ? '250px' : '0',
          transition: 'none', // 移除過渡動畫
        }}
      >
        <div className="container">
          <header 
            className="header"
            style={{backgroundImage: `url(${backgroundImage})`}}
          >
            <h1 className="title">專題演講</h1>
          </header>

          {/* ——— Speaker 1 ——— */}
          <div className={`speaker-wrapper ${isMobile ? 'speaker-wrapper-mobile' : ''}`}>
            <div className={`speaker-content ${isMobile ? 'speaker-content-mobile' : ''}`}>
              <div className="speaker-image-container">
                <img
                  src={require('../assets/蘇添財.png')}
                  alt="教授1"
                  className={`speaker-image ${isMobile ? 'speaker-image-mobile' : ''}`}
                />
              </div>
              <div className="speaker-info">
                <h2 className="speaker-name">蘇添財 中華電信研究院 院長</h2>
                <ul className="speaker-bio-list">
                  <li><strong>演講主題：</strong>AI 賦能 ICT：邁向6G智慧應用新篇章</li>
                </ul>
                <ul className="speaker-bio-list">
                  <li><strong>學歷：</strong>成功大學電機工程碩士</li>
                  <li><strong>現職：</strong>中華電信研究院 院長</li>
                  <li><strong>重要經歷：</strong>
                    <ul>
                      <li>春水堂科技 董事長</li>
                      <li>個人家庭分公司 總經理</li>
                      <li>宏華國際 董事長</li>
                      <li>中華電信行政執行副總(兼投資長與電信學院院長)</li>
                      <li>中華電信經營規劃處 副總經理</li>
                      <li>中華電信電信研究院傳輸技術研究室</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* ——— Speaker 2 ——— */}
          <div className={`speaker-wrapper ${isMobile ? 'speaker-wrapper-mobile' : ''}`}>
            <div className={`speaker-content ${isMobile ? 'speaker-content-mobile' : ''}`}>
              <div className="speaker-image-container">
                <img
                  src={require('../assets/Hwee_Pink_TAN.png')}
                  alt="教授2"
                  className={`speaker-image ${isMobile ? 'speaker-image-mobile' : ''}`}
                />
              </div>
              <div className="speaker-info">
                <h2 className="speaker-name">Dr. Hwee-Pink TAN, Head AiOT, 59stVentures</h2>
                <ul className="speaker-bio-list">
                  <li><strong>Talk tile：</strong>AIoT Systems for Ageing-in-Place: Lessons Learnt and Future Opportunities</li>
                </ul>
                <p className="speaker-bio">Hwee-Pink is an advisor for Singapore's Agency for Science, Technology and Research (A*STAR)'s Scientific Data Strategy Office as well as a consultant for Singapore's Health Promotion Board (HPB) in data change management. He has also been Affiliate Faculty with the Singapore Management University (SMU) Academy since 2019, where he helms the instruction of modules related to Internet of Things (IoT) Technology and Applications and Smart Healthcare. 
Between 2021 and 2023, as HPB's inaugural Chief Data Officer and Director, Research Collaborations and Analytics, Hwee Pink led new teams to advance the data-driven, evidence-based and citizen-centric approach to health promotion through state-of-the-art data best practices to maximize data quality while promoting safe usage of data. 
Between 2015 and 2020, as Associate Professor of Information Systems (Practice) as well as Academic Director of the SMU-TCS iCity lab at SMU's School of Information Systems, he led a cross-disciplinary team to bring together IoT technologies, and social-behavioural research to enable ageing-in-place, in close partnership with A*STAR, TCS, various government agencies, regional health systems as well as Social Service Agencies. 
As Programme Manager for the A*STAR Sense and Sense-abilities Program at the Institute for Infocomm Research (I2R) between 2008 and 2015, he led a research team to design, pilot and evaluate architectures to support large scale and heterogeneous sensor systems to enable Smart City applications. 
He graduated from the Technion, Israel Institute of Technology, Israel in August 2004 with a Ph.D. In December 2004, he was awarded the A*STAR International Fellowship to conduct postdoctoral research at Eindhoven University of Technology and Trinity College Dublin on the design and evaluation of wireless networks.</p>
              </div>
            </div>
          </div>
          
          {/* ——— Speaker 3 ——— */}
          <div className={`speaker-wrapper ${isMobile ? 'speaker-wrapper-mobile' : ''}`}>
            <div className={`speaker-content ${isMobile ? 'speaker-content-mobile' : ''}`}>
              <div className="speaker-image-container">
                <img
                  src={require('../assets/魏宏宇.png')}
                  alt="教授3"
                  className={`speaker-image ${isMobile ? 'speaker-image-mobile' : ''}`}
                />
              </div>
              <div className="speaker-info">
                <h2 className="speaker-name">Prof. Hung-Yu Wei, National Taiwan University</h2>
                <ul className="speaker-bio-list">
                  <li><strong>Talk tile：</strong>Smart Edge Computing and AIoT in the 6G Era</li>
                </ul>
                <p className="speaker-bio">Hung-Yu Wei is a Professor in the Department of Electrical Engineering and Graduate Institute of Communications Engineering (GICE), National Taiwan University (NTU). He is currently the Director of GICE and Chair of IoT Research Center at NTU. From 2019 to 2022, he served as the Interim Chair and Associate Chair of the Department of Electrical Engineering. He received his B.S. degree in electrical engineering from NTU in 1999, and his M.S. and Ph.D. degrees in electrical engineering from Columbia University in 2001 and 2005, respectively. 
                He received the K.T. Li Distinguished Young Scholar Award from ACM Taipei/Taiwan Chapter in 2012, the Excellent Young Engineer Award from CIEE in 2014, the Wu Ta You Memorial Award from MOST in 2015, and the MOST/NSTC Outstanding Research Award in 2020 and 2025. He has also been recognized with the NTU Excellent Teaching Award three times. He serves as Chair of IEEE 1935 working group for edge management and orchestration standard and Chair of IEEE 1934 Working Group for edge/fog computing and networking architecture standard. He is an Associate Editor for IEEE IoT Journal and IEEE IoT magazine. He is an IEEE Fellow and AAIA Fellow.</p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Speech;
